// extracted by mini-css-extract-plugin
export var heading = "logos-section-module--heading--e795c";
export var item = "logos-section-module--item--86b44";
export var logos = "logos-section-module--logos--f2aaf";
export var root = "logos-section-module--root--062a5";